export const trainingSkillConstante = Object.freeze({
  SKILL_CATEGORY_ORIGIN_RNCP: 1,
  SKILL_CATEGORY_ORIGIN_IA: 2,
  SKILL_CATEGORY_ORIGIN_STUDEA: 3,
  SKILL_ORIGIN_RNCP: 1,
  SKILL_ORIGIN_IA: 2,
  SKILL_ORIGIN_STUDEA: 3,
  SKILL_STATUS_SUGGESTED: 1,
  SKILL_STATUS_INTEGRATED: 2,
  OBJECT_TYPE_SKILL: "skill",
  OBJECT_TYPE_MISSION: "mission",
  CRITICALITY_LEVEL_LOW: 1,
  CRITICALITY_LEVEL_MEDIUM: 2,
  CRITICALITY_LEVEL_HIGH: 3,
});
